import { CycleEvaluationEmptyList } from '../CycleEvaluationEmptyList/CycleEvaluationEmptyList';
import { CycleEvaluationTemplateList } from '../CycleEvaluationTemplateList/CycleEvaluationTemplateList';

import type { CycleEvaluation } from '@/types/cycle-evaluation/CycleEvaluation';
import type { CycleEvaluationGroup } from '@/types/cycle-evaluation/CycleEvaluationGroup';
import type { OptionProps } from '@amelio/ui-library';

import { Bone, Skeleton } from '@/components/Skeleton/Skeleton';

export interface CycleEvaluationContentProps {
    isLoading: boolean;
    cycleEvaluationGroups?: CycleEvaluationGroup[];
    cycleEvaluations?: CycleEvaluation[];
    /** Unfiltered evaluation list, used to resolve the template names of each cycle's children. */
    allCycleEvaluations?: CycleEvaluation[];
    actionMenuItems: (cycleEvaluation: CycleEvaluation) => OptionProps[];
    groupActionMenuItems: (group: CycleEvaluationGroup) => OptionProps[];
    isUpdating: boolean;
    currentEvaluation?: CycleEvaluation;
    isRefetching: boolean;
    searchText: string;
    hasActiveFilters: boolean;
    onCreateCycle: () => void;
    onEditEvaluation: (cycleEvaluation: CycleEvaluation) => void;
    onEditGroup: (group: CycleEvaluationGroup) => void;
    currentPage?: number;
    totalCycleCount?: number;
    onCyclePageChange?: (page: number) => void;
}

export const CycleEvaluationContent = ({
    isLoading,
    cycleEvaluationGroups,
    cycleEvaluations,
    allCycleEvaluations,
    actionMenuItems,
    groupActionMenuItems,
    isUpdating,
    currentEvaluation,
    isRefetching,
    searchText,
    hasActiveFilters,
    onCreateCycle,
    onEditEvaluation,
    onEditGroup,
    currentPage,
    totalCycleCount,
    onCyclePageChange,
}: CycleEvaluationContentProps) => {
    if (isLoading || !cycleEvaluations || !cycleEvaluationGroups) {
        return (
            <Skeleton className={'flex flex-col gap-10'}>
                <Bone className={'h-25 w-full'} />

                <Bone className={'h-25 w-full'} />

                <Bone className={'h-25 w-full'} />
            </Skeleton>
        );
    }

    if (cycleEvaluations.length === 0 && cycleEvaluationGroups.length === 0) {
        return (
            <CycleEvaluationEmptyList
                searchText={searchText}
                hasActiveFilters={hasActiveFilters}
                onCreateCycle={onCreateCycle}
            />
        );
    }

    return (
        <CycleEvaluationTemplateList
            cycleEvaluationGroups={cycleEvaluationGroups}
            cycleEvaluations={cycleEvaluations}
            allCycleEvaluations={allCycleEvaluations}
            actionMenuItems={actionMenuItems}
            groupActionMenuItems={groupActionMenuItems}
            isUpdating={isUpdating}
            currentEvaluation={currentEvaluation}
            isRefetching={isRefetching}
            onCreateCycle={onCreateCycle}
            onEditEvaluation={onEditEvaluation}
            onEditGroup={onEditGroup}
            currentPage={currentPage}
            totalCount={totalCycleCount}
            onPageChange={onCyclePageChange}
        />
    );
};
